var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppointmentCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-212 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M18,36A18,18,0,0,1,10.994,1.415,18,18,0,0,1,25.007,34.586,17.889,17.889,0,0,1,18,36ZM18,5.4A12.6,12.6,0,1,0,30.6,18,12.614,12.614,0,0,0,18,5.4Z",
    transform: "translate(212 248)",
    fill: "#081831"
  }), /*#__PURE__*/React.createElement("path", {
    id: "emblem-ok-svgrepo-com",
    d: "M16.22,5.009a1.212,1.212,0,1,0-1.824-1.6L6.778,12.117,4.065,9.4a1.21,1.21,0,1,0-1.711,1.711l3.629,3.629a1.2,1.2,0,0,0,.893.354,1.218,1.218,0,0,0,.874-.411Zm0,0",
    transform: "translate(220.74 256.951)",
    fill: "#081831",
    stroke: "#081831",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentCompletedIcon);
export default __webpack_public_path__ + "static/media/appointmentCompletedIcon.18e7a8aea82743780922472ecf8708dc.svg";
export { ForwardRef as ReactComponent };